import { z } from "zod";
import { MAX_MENTIONS_PER_CONTENT } from "../../utils/mentions.js";
import { MessageMediaType } from "../enum.js";

export const sendMessageSchema = z
	.object({
		content: z.string().max(5000).optional(),
		media_url: z.string().optional(),
		media_type: z.enum([MessageMediaType.IMAGE, MessageMediaType.VIDEO, MessageMediaType.AUDIO]).optional(),
		post_id: z.string().optional(),
		story_id: z.string().optional(),
		reply_to_id: z.string().optional(),
		client_id: z.uuid().optional(),
		mention_ids: z.array(z.uuid()).max(MAX_MENTIONS_PER_CONTENT).optional(),
	})
	.refine((data) => data.content || data.media_url || data.post_id || data.story_id, {
		message: "Either content, media_url, post_id, or story_id must be provided",
	});

export type SendMessagePayload = z.infer<typeof sendMessageSchema>;

export const editMessageSchema = z.object({
	content: z.string().min(1).max(5000),
	mention_ids: z.array(z.uuid()).max(MAX_MENTIONS_PER_CONTENT).optional(),
});

export type EditMessagePayload = z.infer<typeof editMessageSchema>;
